import "./style/mainTemplate.scss";
import "antd/dist/reset.css";
import "react-toastify/dist/ReactToastify.css";
import { Button, Layout, Image, Flex } from "antd";
import { useAppDispatch, useAppSelector } from "../../../util/hooks";
import { setMenu, setPaginaAcesso } from "../../../redux/slices/configuracoes/configuracoesSlice";
import { LogoutOutlined, MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import icon from "./../../../util/assets/icon_login.png";
import HeaderTemplate from "../header/headerTemplate";
import { resetAll, resetPersistedState } from "../../../redux/actions/actions";
import SiderMenu from "../siderMenu/siderMenu";
import { PersistedState } from "../../../redux/slices/persisted/persistedSlice";
import Loading from "../../loading/loading";

const { Footer, Sider, Content } = Layout;

const MainTemplate = ({ children }: any) => {
  //estados globais
  const configuracoesState = useAppSelector((state) => state.configuracoes);
  const persistedState: PersistedState = useAppSelector((state) => state.persisted);

  //hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const sair = () => {
    dispatch(resetAll());
    dispatch(resetPersistedState());
    dispatch(setPaginaAcesso("login"));
    navigate("/", { replace: true });
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        overflow: "hidden",
      }}
    >
      <Sider
        collapsible
        collapsed={configuracoesState.menu}
        collapsedWidth={"80px"}
        trigger={null}
        width={240}
        className="sider"
        style={{
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
        }}
      >
        {persistedState.user.empresa !== null ? (
          configuracoesState.menu ? (
            <div className="logoCollapsed">
              <Image preview={false} src={persistedState.user.empresa.logoPequeno !== null ? persistedState.user.empresa.logoPequeno : undefined} />
            </div>
          ) : (
            <div className="logo">
              <Image preview={false} src={persistedState.user.empresa.logoGrande !== null ? persistedState.user.empresa.logoGrande : undefined} />
            </div>
          )
        ) : (
          //logo padrão
          <div className={configuracoesState.menu ? "logoCollapsed" : "logo"}>
            <Image preview={false} height={39} src={icon} />
            <div className={configuracoesState.menu ? "spanHidden" : "logoText"}>
              <div className="labelLogoGeral">
                <span>GRUPO</span>
              </div>
              <div className="labelLogoGeral">
                <span>PASCHOAL</span>
              </div>
            </div>
          </div>
        )}
        <Button
          type="primary"
          onClick={() => dispatch(setMenu(!configuracoesState.menu))}
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 31,
            marginTop: 25,
            marginLeft: 20,
            backgroundColor: "#ffffff",
            color: "black",
            width: 32,
            height: 32,
            alignItems: "center",
          }}
        >
          {configuracoesState.menu ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </Button>
        <SiderMenu />
        <div className={configuracoesState.menu ? "sairMarginExpanded" : "sair"} onClick={sair}>
          <LogoutOutlined />
          <span className={configuracoesState.menu ? "spanHidden" : ""}>SAIR</span>
        </div>
      </Sider>
      <Layout
        style={
          configuracoesState.menu
            ? { marginLeft: 80, overflow: "auto" }
            : {
                marginLeft: 240,
                overflow: "auto",
              }
        }
      >
        <HeaderTemplate />
        <Content
          style={{
            width: "1200px",
            minWidth: "100%",
            padding: "24px",
          }}
        >
          {children}
        </Content>
        <Footer
          style={{
            backgroundColor: "white",
            padding: 0,
          }}
        ></Footer>
      </Layout>
      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss={false} draggable={false} pauseOnHover />
      <Flex className={configuracoesState.loading ? "loading_component" : "hidden"}>
        <Loading />
      </Flex>
    </Layout>
  );
};

export default MainTemplate;
